import { useOnOutsideClick } from "client/hooks/utils/useOnOutsideClick";
import { useState, useRef, useEffect } from "react";

export const useMobileSelect = <T>(defaultOption: T | null, handleClick: (option: T) => void, value?: T) => {
    const [isFocused, setIsFocused] = useState(false);
    const toggleFocus = () => setIsFocused(!isFocused);

    // for closing the dropdown on outside click
    const ref = useRef<HTMLDivElement>(null);
    useOnOutsideClick<HTMLDivElement>(ref, isFocused, toggleFocus);

    const [selected, setSelected] = useState(defaultOption);

    const handleOptionClick = (option: T) => {
        setSelected(option);
        handleClick(option);
    };

    const handleClose = () => setIsFocused(false);

    useEffect(() => {
        if (typeof value === "undefined") return;
        setSelected(value);
    }, [value]);

    return {
        isFocused,
        toggleFocus,
        ref,
        selected,
        handleOptionClick,
        handleClose,
    };
};
